import { Spinner } from "@fluentui/react";
import { TOrganizationDeactivatorProps } from "./OrganizationDeactivator";
import { useCallback, useState } from "react";
import { portalApi } from "../../../core/api/api";
import { ConfirmProductActivation } from "../../../components/shared/DeleteConfirmation";

export const OrganizationActivator: React.FC<TOrganizationDeactivatorProps> = props => {
    const productId = props.productId;
    const customerId = props.customerId;
    const [initialConfirmationDone, setInitialConfirmationDone] = useState<boolean>(false)

    const activateOrganization = useCallback( async () => {
        setInitialConfirmationDone( true);
        if( productId && '' !== productId) {
            const result = await portalApi.settings.organization.updatePiceaProduct( productId, false);
            console.log( "Product activation:", result.successed)
        }
        if( customerId && '' !== customerId) {
            const result = await portalApi.settings.organization.updatePiceaCustomer( customerId, false);
            console.log( "Customer activation:", result.successed)
        }

        const result = await portalApi.settings.organization.activateOrganization(true);
        console.log( "Organization activation:", result)
        window.location.reload();
    }, [productId, customerId])

    if( !initialConfirmationDone) {
        return (<ConfirmProductActivation
                    onDismiss={props.onCanceled} 
                    onConfirm={activateOrganization} 
                    confirmPhrase={props.organizationName}/>)
    }

    return (<Spinner/>)
}